import _ = require("underscore");
import ol = require("ol");
import Portal = require("portal-gis");
import Utils = require("../utils");
import geo = require("../utils/geo");
import Base = require("./base-command");

class Tool extends Base<{}>{

    static about = `
Trigger when a geolocation even takes place.

Example Usage:

    <EVENT about="pan to current location, chrome requires https" event="current-location" id="current-location-handler" mid="app/commands/geolocation-tool" type="action" />

`;

    static options = {
        "track": {
            about: "see ol.Geolocation tracking, requests notification when device location changes",
            default: "false"
        }
    }

    static output = {
        "position": {
            "about": "the location reported by the browser",
        },
    }
    

    execute(args = this.args) {
        let mediator = this.mediator;
        var options = this.asOptions(Tool.options);

        var tracking = options["track"] === "true";

        mediator.mapView(mapView => {

            let setPosition = (p) => {
                if (!p) return;

                console.log("position change:", p);
                mediator.model.set("ol-geolocation-last-known-good", p);

                p = geo.transform(mapView.getProjection().getCode(), "EPSG:4326", [p])[0];
                mapView.panTo(p);

                this.trigger({ position: p });
            }

            let geolocation = <ol.Geolocation>mediator.model.get("ol-geolocation");

            if (!geolocation) {
                geolocation = new ol.Geolocation({
                    projection: mapView.getProjection(),
                    tracking: true
                });
                mediator.model.set("ol-geolocation", geolocation);

                geolocation.on('change', function (evt) {
                    setPosition(geolocation.getPosition());
                });
            }


            setPosition(mediator.model.get("ol-geolocation-last-known-good"));

        });

    }

}

export = Tool;
